<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { vodafoneLabContactMixin } from "../../modules/vodafone_lab_mixins_module.js"
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabBasicMixin, vodafoneLabContactMixin],
  data: function () {
    return { };
  },
  methods: {
    toggleVideoPopup() {
      if(this.isVideoPresent) {
        Vue.set(globalState, "videoPopupContent", { content: this.content, containerContent: this.containerContent });
      }
    },
  },
  computed: {
    isVideoPresent() {
      return !!this.content.play;
    },
    canUserPlayVideo() {
      const registrationRequired = get(this, ["content", "registration_required"], false);
      return registrationRequired ? !get(globalState, ["pageModel", "user", "anonymous"], false) : true;
    },
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 7);
      return [
        `col-lg-${columnWidth}`
      ];
    },
    aspectRatioClasses: function() {
      return [
        (Fandom.exists(this.content.height) && this.content.height.indexOf("$") === 0) ? this.content.height.replace("$", "ar-") : "ar-16by9",
      ];
    },
    mediaColumnClasses: function() {
      const classes = [];
      // d-md-block preserve image column from md breakpoint.
      if (!Fandom.exists(this.content.image) && !Fandom.exists(this.content.video)) {
        classes.push("d-none d-lg-block")
      }
      if (this.canUserPlayVideo && this.content.play) {
        classes.push("cursor-pointer");
      }
      return classes;
    },
  }
};
</script>

<template>
  <div 
    v-if="isContentVisibleToUser()" 
    v-easyadmin="easyadminId" 
    :class="contentType"
    page-article
    page-article-video-component
    class="position-relative"
  >
    <breadcrumb :absolute="false"></breadcrumb>
    <div class="video-container">
      <div class="container-md">
        <div class="row justify-content-center">
          <div class="col-12 media-column d-inline-flex align-items-center" :class="mediaColumnClasses">
            <embed-advanced :content="content" class="w-100" :opt-container-content="containerContent" :can-user-play-video="canUserPlayVideo"></embed-advanced>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-4 mb-md-5">
      <stripe-article-interactions
        v-if="content.share"
        class="justify-content-end"
        :content="content"
        :key="content.share.$id"
        :opt-container-content="containerContent"
      ></stripe-article-interactions>
      <page-article-red-banner :content="content.red_banner" :opt-container-content="containerContent" v-if="content.red_banner"></page-article-red-banner>
    </div>
    <div class="container mt-4" v-if="lastUpdatedAt">
      <div class="row justify-content-center">
        <div class="col-lg-7 small">{{ft('globals.updated_at')}} {{lastUpdatedAt}}</div>
      </div>
    </div>
    <div class="container mt-4 mt-md-5">
      <div class="row justify-content-center">
        <div class="col-12" :class="columnClasses">
          <h1 class="h2 display-1 mb-4 mb-md-5" v-if="content.title">{{content.title}}</h1>
        </div>
      </div>
    </div>
    <component
      :key="stripe.$id"
      :content="stripe"
      :is="stripe.layout"
      :opt-container-content="containerContent"
      v-for="(stripe) in content.stripes"
    ></component>
    <div class="container py-4 py-md-5" v-if="content.decorators['category']">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-7">
          <div class="d-flex flex-wrap">
            <a v-for="category in (content.decorators['category'] || [])" class="btn btn-sm btn-outline-primary rounded-pill px-3 py-1 mx-2" :href="applyContextToUrl(pageModel.decorators.category[category].slug)">
              {{pageModel.decorators.category[category].title}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <vote-interaction class="mb-md-5 pb-3" :content="content" v-if="content.vote"></vote-interaction>
    <related-collections :content="content"></related-collections>
    <stripe-contact-us :content="contactStripe" v-if="contactStripe"></stripe-contact-us>
  </div>
</template>

<style lang="scss">
[page-article-video-component] {

  .video-container {
    background-color: $dark;
  }

  .media-column, .video-cover {
    border-radius: 6px;
  }

  .author-image {
    max-height: 5rem;
    max-width: 10rem;
    height: auto;
    width: auto;
    display: inline-block;
  }

  @include media-breakpoint-down(sm) {
    .media-column, .video-cover {
      border-radius: 0px;
    }
  }
}
</style>
